import { ResponseType, PaginationResponseType } from 'types/response.d';
import { TenantType } from 'types/entities/tenants.d';
import { TenantCriteria } from 'types/models/tenants.d';
import { UserType } from 'types/user.type';
import { get, post, put } from './axios';

const url = `/tenants`;

export const getById = (id: number): Promise<ResponseType<TenantType>> => get(`${url}/${id}`);

export const filter = (request: TenantCriteria): Promise<PaginationResponseType<TenantType[]>> =>
  get(url, { params: { ...request } });

export const update = (id: number, request: TenantType): Promise<ResponseType<TenantType>> =>
  put(`${url}/${id}`, request);

export const create = (request: TenantType): Promise<ResponseType<TenantType>> =>
  post(url, request);

export const filterUrForAddingTenant = (request: {
  email: string;
}): Promise<PaginationResponseType<UserType[]>> => get(`${url}/users`, { params: { ...request } });
